const React = require('react');
const { useTranslation } = require('react-i18next');
const GlobalSearchResultRow = require('./GlobalSearchResultRow');

const GlobalSearchEmptyState = ({ message }) => (
  <div className='globalSearchResults__empty'>{message}</div>
);

/**
 * The rows under the input.
 *
 * With a query these are the search results. With an empty box they are the
 * fields visited this session (see recentFieldsStore) — the same rows, so
 * hovering, arrow keys and Enter all work the same way. The typing hint is
 * only shown when there is no trail to offer instead.
 */
const GlobalSearchResults = ({
  entries,
  totalMatches,
  hasQuery,
  activeIndex,
  onSelect,
  onHover,
  rowRefs,
}) => {
  const { t } = useTranslation();

  if (entries.length === 0) {
    return (
      <GlobalSearchEmptyState
        message={
          hasQuery
            ? t('global_search_no_results')
            : t('global_search_empty_hint')
        }
      />
    );
  }

  return (
    <React.Fragment>
      {hasQuery ? null : (
        <div className='globalSearchResults__section'>
          {t('global_search_recent_fields')}
        </div>
      )}
      {entries.map((entry, index) => (
        <GlobalSearchResultRow
          key={entry.key}
          entry={entry}
          index={index}
          isActive={index === activeIndex}
          onSelect={onSelect}
          onHover={onHover}
          rowRef={(node) => {
            rowRefs.current[index] = node;
          }}
        />
      ))}
      {hasQuery && totalMatches > entries.length ? (
        <div className='globalSearchResults__truncated'>
          {/* `shown`, not `count` — i18next treats `count` as a plural key. */}
          {t('global_search_more_results', {
            shown: entries.length,
            total: totalMatches,
          })}
        </div>
      ) : null}
    </React.Fragment>
  );
};

module.exports = GlobalSearchResults;
